// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { PropsWithChildren } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, Tooltip } from '@mui/material';
import { useCopyToClipboard } from './useCopyToClipboard';

const CopyToClipboard = ({
  children,
  buttonClassName,
  tooltipText,
  value,
  disableIcon,
}: PropsWithChildren<{
  buttonClassName: string;
  tooltipText: string;
  value: string;
  disableIcon?: boolean;
}>) => {
  const copyToClipboard = useCopyToClipboard();
  return (
    <>
      {/* Display the copy button in case the value is not empty */}
      {value && (
        <Tooltip title={tooltipText} arrow>
          <Button
            className={buttonClassName}
            color="inherit"
            size="small"
            variant="text"
            startIcon={disableIcon ? null : <ContentCopyIcon />}
            onClick={(e) => {
              e.stopPropagation();
              copyToClipboard(value);
            }}
            sx={{ textTransform: 'none' }}
          >
            {children}
          </Button>
        </Tooltip>
      )}
      <div style={{ display: 'none' }} aria-hidden="true" aria-label="user-primary-party-id">
        {value}
      </div>
    </>
  );
};

export default CopyToClipboard;
